const message = {
  success: 'Thành công',
  createTargetSuccess: 'Tạo mục tiêu thành công',
  deleteTargetSuccess: 'Xóa mục tiêu thành công',
  createTargetGroupSuccess: 'Tạo mục nhóm tiêu thành công',
  deleteTargetGroupSuccess: 'Xóa mục nhóm tiêu thành công',
  updateTargetGroupSuccess: 'Cập nhật nhóm tiêu thành công',
  addTargetToGroupSuccess: 'Thêm mục tiêu vào nhóm thành công',
  removeTargetFromGroupSuccess: 'Xóa mục tiêu khỏi nhóm thành công',
  deleteScanProfileSuccessfully: 'Xoá hồ sơ bản quét thành công',
  updateExcludedHoursProfileSuccess:
    'Cập nhật hồ sơ thời gian quét loại trừ thành công',
  createExcludedHoursProfileSuccess:
    'Tạo hồ sơ thời gian quét loại trừ thành công',
  createProfileSuccessfully: 'Tạo hồ sơ bản quét thành công',
  editProfileSuccessfully: 'Cập nhật hồ sơ bản quét thành công',
  updateUserSuccessfully: 'Cập nhật người dùng thành công',
  createUserSuccess: 'Tạo người dùng thành công',
  generateScanComparisonReportSuccess:
    'Tạo báo cáo so sánh bản quét thành công',
  deleteReportsSuccess: 'Xóa báo cáo thành công',
  statusChanged: 'Thay đổi trạng thái thành công',
  reCheckSuccess: 'Quá trình quét đã được tạo để kiểm tra lỗ hổng đã chọn',
  downloadWillStart: 'Quá trình tải xuống của bạn sẽ bắt đầu sau giây lát',
  reportIsBeingGenerated: 'Báo cáo đang được tạo',
  createWebsiteSuccess: 'Thêm Website thành công',
  updateWebsiteSuccess: 'Cập nhật Website thành công',
  createUnitListSuccess: 'Tạo đơn vị thành công',
  updateUnitListSuccess: 'Cập nhật đơn vị thành công'
};

export default message;
